// Module
var code = "<template bindable=\"nylontype\">\n    <div class=\"form-element\">\n      <label for=\"name\" t=\"general.name\"></label>\n      <input type=\"text\" name=\"name\" value.bind=\"nylontype.Name\">\n    </div>\n</template>\n";
// Exports
export default code;